import { resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "main-content-container",
    "data-cy": "codes-page"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-auto me-auto" };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "col me-auto" };
const _hoisted_8 = { class: "col-auto" };
const _hoisted_9 = { class: "row" };
const _hoisted_10 = { class: "row" };
const _hoisted_11 = { class: "col" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_acl = _resolveDirective("acl");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createVNode($setup["AddCodeModal"], {
            ref: "addCodeModal",
            access: $props.access,
            onAdded: $setup.refetch
        }, null, 8, ["access"]), [
            [_directive_acl, $props.access, "privileged"]
        ]),
        _withDirectives(_createVNode($setup["EditCode"], {
            ref: "editCodeModal",
            access: $props.access,
            onUpdated: $setup.refetch
        }, null, 8, ["access"]), [
            [_directive_acl, $props.access, "privileged"]
        ]),
        _withDirectives(_createVNode($setup["DeleteCode"], {
            ref: "deleteCodeModal",
            access: $props.access,
            onDeleted: $setup.refetch
        }, null, 8, ["access"]), [
            [_directive_acl, $props.access, "privileged"]
        ]),
        ($setup.codesQuery.loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode($setup["BContainer"], { fluid: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('JTADM_CODES_HEADER')), 1)
                            ]),
                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-auto" }, "Loading", -1))
                        ])
                    ]),
                    _: 1
                })
            ]))
            : ($setup.codes.length >= 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode($setup["BContainer"], { fluid: "" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('JTADM_CODES_HEADER')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode($setup["BButton"], {
                                        variant: "secondary",
                                        onClick: $setup.addCodeModal?.show
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode("+ " + _toDisplayString(_ctx.$t('JTADM_CODES_CREATE_CODE')), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["onClick"])
                                ])
                            ]),
                            _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode($setup["Card"], {
                                    number: $setup.filteredByTenant.length,
                                    role: undefined,
                                    text: _ctx.$t('JTADM_CODES_TOTAL'),
                                    icon: "dripicons-lock-open",
                                    "bg-color": "bg-aqua"
                                }, null, 8, ["number", "text"]),
                                _createVNode($setup["Card"], {
                                    number: $setup.activeCount,
                                    role: undefined,
                                    text: _ctx.$t('JTADM_CODES_ACTIVES'),
                                    icon: "dripicons-checkmark",
                                    "bg-color": "bg-green"
                                }, null, 8, ["number", "text"]),
                                _createVNode($setup["Card"], {
                                    number: $setup.expiringCount,
                                    role: undefined,
                                    text: _ctx.$t('JTADM_CODES_EXPIRING'),
                                    icon: "dripicons-clock",
                                    "bg-color": "bg-red"
                                }, null, 8, ["number", "text"])
                            ]),
                            _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                            _createVNode($setup["CommonSearchInput"], {
                                "model-value": $setup.searchQuery,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.searchQuery) = $event)),
                                "data-cy": "code-search",
                                placeholder: _ctx.$t('JTDAM_SEARCH_CODE'),
                                onRefetch: $setup.refetch
                            }, null, 8, ["model-value", "placeholder"]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    ($setup.gridData)
                                        ? (_openBlock(), _createBlock($setup["Grid"], {
                                            key: 0,
                                            "data-cy": "code-list",
                                            data: $setup.gridData,
                                            columns: $setup.gridColumns,
                                            "filter-key": $setup.searchQuery,
                                            access: $props.access,
                                            onDelete: _cache[1] || (_cache[1] = ($event) => ($setup.deleteCodeModal?.show($event))),
                                            onEdit: _cache[2] || (_cache[2] = ($event) => ($setup.editCodeModal?.show($event)))
                                        }, null, 8, ["data", "columns", "filter-key", "access"]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]),
                        _: 1
                    })
                ]))
                : _createCommentVNode("", true)
    ]));
}
